import { useMutation } from 'react-query';

import { extractProductivityTableCardToCsv as mutationFn } from 'api/endPoints/extractProductivityTableCardToCsv';

import { Range } from 'components/common/GlobalFiltersInPage/components/RangeFilter/rangeFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFiltersInPage/components/quickAnswerFilter/quickAnswerFilter';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Aggregation } from 'components/widgets/ResourcesAnalysisChart/ResourcesAnalysisChart.consts';

export const useMutationExtractProductivityTableCardToCsv = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    actualMetaDataId: number | undefined;
    comparedMetaDataId: number | undefined;
    range: Range | undefined;
    startDate: number | null;
    endDate: number | null;
    filter: {
        filters: IFilter[];
    };
    aggregation: Aggregation;
    quickAnswerFilter?: QuickAnswerFilter;
    fileName?: string;
}
